import Laser247Logo from "../../assets/images/brand/title.png";
import LoginPageBanner from "../../assets/login_page_banner.webp";
import LoginSection from "../components/header/LoginSection";
import CrossIcon from "../../assets/icons/cross-icon.svg";
import { Navigate, useNavigate } from "react-router-dom";
import { getEnvVariable } from "../../constants/brandConfig";
import { domain } from "../../constants/Branding";
import { useAppSelector } from "@hypexone/uicore";

const MobileLoginPage = () => {
  const navigate = useNavigate();
  const { loggedIn } = useAppSelector((state) => state.auth);

  if (loggedIn) {
    return <Navigate to="/home" replace />;
  }

  return (
    <div className="flex flex-col w-full bg-goldenYellow min-h-screen">
      {/* Header: dark background, logo centered, close top-right */}
      <header
        className="relative flex flex-col items-center justify-center h-[36vh] pt-12 pb-8 px-4 shrink-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${LoginPageBanner})` }}
      >
        <button
          type="button"
          onClick={() => navigate('/home', { replace: true })}
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-black flex items-center justify-center p-2 hover:opacity-90"
          aria-label="Close"
        >
          <img
            src={CrossIcon}
            alt=""
            className="w-full h-full [filter:brightness(0)_invert(1)]"
          />
        </button>
        <img src={getEnvVariable(domain, "logo")} alt="logo" className="h-[110px] object-contain" />
      </header>

      {/* Main content: golden yellow */}
      <main className="flex-1 flex justify-center px-6 py-3 md:py-6 md:mt-4">
        <div className="w-full max-w-sm">
          <LoginSection isMobileScreen />
        </div>
      </main>

      {/* Bottom bar */}
      <div className="h-1.5 w-full bg-black shrink-0" />
    </div>
  );
};

export default MobileLoginPage;
